export const DESKTOP_COLUMN_WIDTH = 320 // max width of Artwork Data
export const DESKTOP_COLUMN_GAP = 30 // max width of Artwork Data
export const MOBILE_COLUMN_WIDTH = 140 // 2 Column Experience Mobile
export const MOBILE_COLUMN_GAP = 0 // 2 Column Experience Mobile
export const SPAN_HEIGHT = 25 // grid-auto-rows: 25px;
export const TABLET_WIDTH = 1024
export const MOBILE_WIDTH = 768
export const MasonryWidth = 280
export const gridRowGap = 13
export const gridColumnGap = 50
export const gridAutoRows = 20
